const GALLONS_PER_ACRE_PER_LITER_PER_HECTARE = 0.106907;
const POUNDS_PER_ACRE_PER_KILOGRAM_PER_HECTARE = 0.892179;

/**
 * Converts liquid application rate from liters per hectare to gallons per acre,
 * rounded to two decimal places.
 */
export function litersPerHectareToGallonsPerAcre(litersPerHectare: number): number {
    return Math.round(litersPerHectare * GALLONS_PER_ACRE_PER_LITER_PER_HECTARE * 100) / 100;
}

export function gallonsPerAcreToLitersPerHectare(gallonsPerAcre: number): number {
    return Math.round((gallonsPerAcre / GALLONS_PER_ACRE_PER_LITER_PER_HECTARE) * 100) / 100;
}

export function kilogramsPerHectareToPoundsPerAcre(kilogramsPerHectare: number): number {
    return Math.round(kilogramsPerHectare * POUNDS_PER_ACRE_PER_KILOGRAM_PER_HECTARE * 100) / 100;
}

export function poundsPerAcreToKilogramsPerHectare(poundsPerAcre: number): number {
    return Math.round((poundsPerAcre / POUNDS_PER_ACRE_PER_KILOGRAM_PER_HECTARE) * 100) / 100;
}

const GAL_PER_AC_PER_LPM_PER_M_PER_M_PER_S = 4046.8564224 / (3.78541 * 60);

type AppliedRateInputs = {
    flowRateLitersPerMinute: number;
    speedMetersPerSecond: number;
    swathWidthMeters: number;
};

/**
 * Converts instantaneous flow × ground speed × swath width into applied
 * liquid rate in gallons per acre. Returns 0 when any denominator term is
 * zero (stationary drone or unset swath), since no area is being covered.
 */
export function calculateAppliedRateGalPerAc({
    flowRateLitersPerMinute,
    speedMetersPerSecond,
    swathWidthMeters
}: AppliedRateInputs): number {
    if (flowRateLitersPerMinute <= 0 || speedMetersPerSecond <= 0 || swathWidthMeters <= 0) {
        return 0;
    }

    const numerator = flowRateLitersPerMinute * GAL_PER_AC_PER_LPM_PER_M_PER_M_PER_S;
    const denominator = swathWidthMeters * speedMetersPerSecond;

    return Math.round((numerator / denominator) * 100) / 100;
}
